module.exports = __webpack_public_path__ + "img/ewm.d1e4c0d0.jpg";